import React from 'react';
import withLoading from 'app/ui/core/common/withLoading';
import SelectUIBase from '../../config/SelectUIBase';
import HundredPercentContainer from '../../core/common/HundredPercentContainer';
import { PreloadReaderPage } from '../reader/ReaderPage';
import { createUiBaseMountAction } from '../../config/createUiBaseMountAction';
import MountAfterTransition from '../shared/MountAfterTransition';
import InitPageData from './common/InitPageData';

const MiddleHomeMain = withLoading(() => import('./middle/MiddleHomeMain'));
const KiddieHomeMain = withLoading(() => import('./kiddie/KiddieHomeMain'));

export const PreloadHomePage = createUiBaseMountAction(
  KiddieHomeMain.preload,
  MiddleHomeMain.preload
);

export default class HomePage extends React.Component {
  render() {
    return (
      <HundredPercentContainer>
        <SelectUIBase>
          <KiddieHomeMain />
          <MiddleHomeMain />
        </SelectUIBase>
        <MountAfterTransition>
          <PreloadReaderPage />
        </MountAfterTransition>
        <InitPageData />
      </HundredPercentContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/pages/home/HomePage.js